import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "variant"],
  _excluded2 = ["children"];
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import { BreezeIcon } from '../Icons/BreezeIcon';
import { ButtonContent } from './ButtonContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const USAGE_TRACKER = 'WE HAVE CUSTOM TRACKING IN PLACE AND AI-EXTENSIBILITY TEAM IS AWARE';
export const ButtonBreeze = _ref => {
  let {
      children,
      variant = 'primary'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AIButton, Object.assign({}, rest, {
    showBreezeIcon: false,
    usageTracker: USAGE_TRACKER,
    use: variant,
    children: /*#__PURE__*/_jsx(ButtonContent, {
      children: children
    })
  }));
};
export const ButtonIconBreeze = _ref2 => {
  let {
      children
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(ButtonBreeze, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(BreezeIcon, {
      variant: "default"
    }), children]
  }));
};